import React, { useState } from 'react'
import BaseSelect from 'shared/components/base/form/base-select'

import { ALL_WIDGETS, RenderWidget } from './widgets.constants'

const WeightWidget = () => {
  const [selectedProductName, setSelectedProductName] = useState('')
  const handleSelect = (selectedProductTypeOption: string) => {
    setSelectedProductName(selectedProductTypeOption)
  }

  return (
    <>
      <BaseSelect
        className="w-[209px]  "
        onSelect={handleSelect}
        label="انتخاب محصول:"
        options={ALL_WIDGETS as any}
        labelProps={{
          variant: 'salesLabel',
          className: 'font-medium z-50 text-2.5 text-white',
        }}
      />

      <React.Suspense fallback={<div>loading...</div>}>
        <RenderWidget selectedProductType={selectedProductName} />
      </React.Suspense>
    </>
  )
}

export default WeightWidget
